import api from '@/services/api'

export default {
  createCart(companyId, customerId) {
    return api.post('/sales/cart', { companyId, customerId });
  },

  getCart(cartId) {
    return api.get(`/sales/cart/${cartId}`);
  },

  recalculateCart(cartId, data) {
    return api.post(`/sales/cart/${cartId}/recalculate`, data);
  },

  updateCart(cartId, data) {
    return api.put(`/sales/cart/${cartId}`, data);
  },

  getSales(params, page) {
    let queryString = `?page=${page || 1}`;

    if (params.customer) {
      queryString += `&customer=${params.customer}`;
    }

    if (params.startDate) {
      const startDate = new Date(params.startDate);
      queryString += `&startDate=${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
    }

    if (params.endDate) {
      const endDate = new Date(params.endDate);
      queryString += `&endDate=${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
    }

    queryString += `&status=sale`;

    return api.get(`/sales${queryString}`);
  },

  getOrders(params, page) {
    let queryString = this.createOrdersQueryString(params, page);
    return api.get(`/sales${queryString}`);
  },

  exportOrders(params) {
    let queryString = this.createOrdersQueryString(params) + '&export=true';

    return api({
      url: `/sales${queryString}`,
      method: 'GET',
      responseType: 'blob',
    })
  },

  createOrdersQueryString(params, page = null) {
    let queryString = `?page=${page || 1}`;

    if (params.customer) {
      queryString += `&customer=${params.customer}`;
    }

    if (params.period) {
      if (params.startDate) {
        const startDate = new Date(params.startDate);
        queryString += `&startDate=${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate()}`;
      }

      if (params.endDate) {
        const endDate = new Date(params.endDate);
        queryString += `&endDate=${endDate.getFullYear()}-${endDate.getMonth() + 1}-${endDate.getDate()}`;
      }
    }

    if (params.code) {
      queryString += `&code=${params.code}`;
    }

    if (params.attendanceCode) {
      queryString += `&attendanceCode=${params.attendanceCode}`;
    }

    if (params.seller) {
      queryString += `&seller=${params.seller}`;
    }

    queryString += `&status=order`;

    return queryString;
  },

  getCarriers() {
    return api.get('/carriers');
  },

  getPaymentMethods() {
    return api.get('/payment-methods');
  },

  getPaymentConditions(cartId) {
    return api.get(`/payment-conditions?cart=${cartId}`);
  },

  addItem(cartId, data) {
    return api.post(`/sales/cart/${cartId}/add`, data);
  },

  removeItem(cartId, product) {
    return api.post(`/sales/cart/${cartId}/remove`, {
      product,
    });
  },

  changeQuantity(cartId, product, quantity) {
    return api.post(`/sales/cart/${cartId}/change-quantity`, {
      product,
      quantity,
    });
  },

  removeSale(id) {
    return api.delete(`/sales/${id}`);
  },
}